import React from 'react';
import { inputClass, labelClass } from './adminFormStyles';

const AdminFormField = ({
  label,
  required,
  hint,
  children,
  className = ''
}) => (
  <div className={className}>
    {label && (
      <label className={labelClass}>
        {label}
        {required && <span className="text-orange-500 ml-0.5">*</span>}
      </label>
    )}
    {children || null}
    {hint && <p className="text-[11px] text-gray-400 mt-1">{hint}</p>}
  </div>
);

export const AdminInput = ({ className = '', ...props }) => (
  <input className={`${inputClass} ${className}`} {...props} />
);

export const AdminTextarea = ({ className = '', rows = 3, ...props }) => (
  <textarea className={`${inputClass} resize-y min-h-[72px] ${className}`} rows={rows} {...props} />
);

export const AdminSelect = ({ className = '', children, ...props }) => (
  <select className={`${inputClass} ${className}`} {...props}>
    {children}
  </select>
);

export default AdminFormField;
